import NotificationsDropdown from './Notifications';
import ThemeToggle from '../Helper/ThemeToggle';
import { SidebarTrigger } from '@/components/ui/sidebar';
import Breadcrumb from '../Breadcrumb';
import { useLocation } from 'react-router-dom';
import { cn } from '@/utils/classnames';

export default function Header() {
  const location = useLocation();
  const isUserDetail =
    !!location.pathname.match(/^\/users\/(?!create-user$)[^/]+$/) ||
    location.pathname.startsWith('/settings');
  return (
    <>
      <header className="bg-transparent border-b border-[#c2daff] dark:border-[#434B5A] lg:border-none px-[1rem] md:px-[3rem] py-3 flex items-center justify-between">
        {/* Left side - Page Title & Breadcrumb */}
        <div className="lg:flex-col lg:gap-[1rem]">
          <Breadcrumb />
        </div>

        {/* Mobile Logo - centered */}
        <div className="logo lg:hidden flex justify-center absolute left-1/2 transform -translate-x-1/2">
          <img className="w-[12rem]" src="/src/assets/svg/logo.svg" alt="" />
        </div>

        {/* Right side - 50% width on mobile */}
        <div className="flex items-center gap-[0.8rem] md:gap-[1.2rem] lg:gap-[1.5rem] w-1/2 lg:w-auto justify-end">
          {/* Notifications Dropdown */}
          <NotificationsDropdown />

          {/* Theme Toggle */}
          <div className={cn("block", isUserDetail && "hidden lg:block")}>
            <ThemeToggle />
          </div>

          <SidebarTrigger className="xl:hidden" />
        </div>
      </header>
      {/* <div className="w-full h-[0.1rem] bg-button-main mt-[0.5rem]" /> */}
    </>
  );
}
